import config from '@/lib/config';
import user from '../user';

const isNormalRoom = () => {
  return location.href.indexOf('/client/room') > -1;
};

const isPartyRoom = () => {
  return location.href.indexOf('/client/party') > -1;
};

const redirectRoom = (roomId) => {
  location.href = `${process.env.basePath}/client/room?id=${roomId}`;
};

const redirectParty = (roomId) => {
  location.href = `${process.env.basePath}/client/party?id=${roomId}`;
};

const exitApp = () => {
  location.href = '/';
};
const relaunchApp = () => {
  location.href = '/';
};

const redirectLogin = () => {
  if (config.inPcClient) {
    location.href = `${process.env.basePath}/client/login`;
  } else {
    user.popupLogin();
  }
};

const closeWindow = () => {};

const minimizeWindow = () => {};
const maximizeWindow = () => {};
const toggleMaximizeWindow = () => {};

const getPageUrl = (pagePath) => {
  return `${location.origin}${process.env.basePath}${pagePath}`;
};

const checkUpdate = () => {};

const getSystemInfo = (onSuccess) => {};
const getProcessInfo = (onSuccess) => {};

const reload = () => {
  location.reload();
};

const selectImage = () => {};

const downloadGame = ({ url, gameKey }) => {
  window.open(url);
};

const openGame = (options) => {};
const removeGame = (options) => {};

const getGameList = () => {};

const selectVideo = () => {
  return new Promise((resolve, reject) => {
    reject();
  });
};
const getTextAudio = (text) => {
  return new Promise((resolve, reject) => {
    reject();
  });
};

const AppClient = {
  isNormalRoom,
  isPartyRoom,
  redirectRoom,
  redirectParty,
  exitApp,
  relaunchApp,
  redirectLogin,
  closeWindow,
  minimizeWindow,
  maximizeWindow,
  toggleMaximizeWindow,
  getPageUrl,
  checkUpdate,
  getSystemInfo,
  getProcessInfo,
  reload,
  selectImage,
  downloadGame,
  openGame,
  removeGame,
  getGameList,
  getTextAudio,
  selectVideo,
};

export default AppClient;
